import React from "react"
import styled from "styled-components"

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin: 2rem 0;
  padding: 0;
`

const Title = styled.h2`
  width: 80%;
  margin: 0 auto;
  padding: 0;
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
  letter-spacing: .13em;
  @media screen and (max-width: ${(props) => props.breakpoints - 1}px) {
    width: 80%;
  }
`

const Description = styled.p`
  display: inline-block;
  width: 60%;
  margin: 1.5rem auto;
  padding: 0;
  font-size: 0.9rem;
  letter-spacing: .06em;
  @media screen and (max-width: ${(props) => props.breakpoints - 1}px) {
    width: 80%;
  }
`

export const SimpleSubTitle = ({title, description, breakpoints}) => {
  return (
    <Wrapper breakpoints={breakpoints}>
      <Title breakpoints={breakpoints}>{title}</Title>
      <Description breakpoints={breakpoints}>{description}</Description>
    </Wrapper>
  )
}